"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataEngine = void 0;
const DataEngine_1 = require("./DataEngine");
Object.defineProperty(exports, "DataEngine", { enumerable: true, get: function () { return DataEngine_1.DataEngine; } });
//# sourceMappingURL=index.js.map